// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { styles } from "@bg/App/Components/MyCustomQuotes/MyCustomQuotesQuoteLine";
import { linkIconStyleGenerator } from "@bg/App/SharedStyles/GeneralStyles";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.dragHandleIcon = {
    src: "Drag",
    color: "tertiary",
    size: 17,
    css: css`
        cursor: move;
        opacity: 0.7;
        @media (max-width: 1025px) {
            display: none;
        }
    `,
};

styles.quantityGridItem = {
    css: css`
        && button:last-child {
            border-right: 2px solid ${getColor("text")} !important;
        }
    `,
};

styles.deleteLink = {
    css: css`
        &&& {
            min-width: auto;
            background: transparent;
            padding: 0;
            min-height: unset;
            svg {
                fill: ${getColor("tertiary")};
            }

            &:hover svg {
                fill: ${getColor("primary")};
            }
        }
    `,
};

styles.quotePriceInput = {
    css: css`
        ${styles.quotePriceInput?.css}
        &&& input {
            background: ${getColor("common.ui4")};
        }
    `,
};

styles.addRelatedProductLink = linkIconStyleGenerator(
    "Search",
    "13px",
    14,
    "line-height: 18px; color: #131313 !important;",
    "color:#9C822F;",
);
styles.calculateMargin = linkIconStyleGenerator(
    "Calculator",
    "13px",
    14,
    "line-height: 18px; color: #131313 !important;",
    "color:#9C822F;",
);
styles.toggleLink = linkIconStyleGenerator(
    "Create",
    "13px",
    14,
    "line-height: 18px; color: #131313 !important;",
    "color:#9C822F;",
);
styles.printQrCode = linkIconStyleGenerator(
    "QrCode",
    "13px",
    15,
    "opacity: 0.8;line-height: 16px;color: #131313 !important;",
    "color:#9C822F;",
);
